/* eslint-disable */
import {http} from '@/helpers/http';

const defaultResidential = {
    id: 'new',
    latitude: 0,
    layouts: [],
    longitude: 0,
    is_active: false, // Активность
    name: '', // Название
    alias: '', // Символьный код
    developer_id: null, // Застройщик
    position: '', // ???
    completion_deadline_from: null, // Срок сдачи от
    completion_deadline_to: null, // Срок сдачи до
    district_id: null, // Район
    address: '', // Адрес
    advantages: [],
    layouts_advantages: [],
    materials: [],
    decorations: [], // Отделка
    floors: [],
    wirings: [], // Разводка
    balconies: [], // Балконы
    banks: [], // Банки
    elevators: [],
    features: [], // Во дворе
    ext_features: [],
    infrastructures: [], // рядом
    ext_infrastructures: [],
    short_description: '',

    preview_text: '',
    detail_text: '',

    plans: [],

    rooms: {},

    sales_department_formulation: false,

    images: [],
    original_image: '',
    preview_picture: '',

    is_wide_logo_description: false,
    form: false, // Формулировка "Отдел продаж" - смешное название переменной))
    is_apartments: false, // Формулировка "Апартаменты"
    no_developer_logo: false,
    developer_url: '',
    price_list: null,

    price: {
        five_rooms: null,
        five_rooms_studio: null,
        four_rooms: null,
        four_rooms_studio: null,
        free: null,
        one_room: null,
        one_room_studio: null,
        six_rooms: null,
        six_rooms_studio: null,
        three_rooms: null,
        three_rooms_studio: null,
        two_rooms: null,
        two_rooms_studio: null,
    },

    // Вкладка SEO
    seo_title: '',
    seo_description: '',
    seo_keywords: '',
};

const stringToNumber = (obj) => {
    return Object.keys(obj).reduce((newObject, key) => {
        return {...newObject, [key]: Number(obj[key])};
    }, {});
};

export default {
    namespaced: true,
    state() {
        return {
            list: [], // Список застройщиков
            search: '', // Поисковое слово в списке
            current: defaultResidential,
        };
    },

    mutations: {
        /* Записать новый список */
        setList(state, data) {
            state.list = data.slice();
        },

        /* Установить поисковое слово */
        setSearch(state, data) {
            state.search = data;
        },

        /* Установить свойство текущего объекта */
        setValue(state, payload) {
            console.log('statebefor', state.current);
            state.current = {
                ...state.current,
                ...payload
            };
            console.log('stateAfter', state.current);
            console.log("ssssssssssss", payload);
        },

        /* Очистить текущее значение */
        clearCurrent(state) {
            state.current = {
                ...state.current,
                ...defaultResidential
            }
        },

        /* Удалить из списка */
        removeFormList(state) {
            const index = state.list.findIndex(({id}) => id === state.current.id);
            state.list.splice(index, 1);
        },

        /* Установить текущий объект по идентификатору */
        setCurrent(state, _id) {
            const promo = state.list.find(({id}) => id === _id)
            state.current = {
                ...state.current,
                ...promo
            }
        },

        /* Заменить по идентификатору */
        replaceById(state, current) {
            const index = state.list.findIndex(({id}) => id === current.id);
            state.list.splice(index, 1, current);
        },

        /* Добавить в список */
        addList(state, current) {
            state.list.push({...current, id: state.list.length + 1});
        }
    },

    getters: {
        // getList: state => state.list.filter(({ title }) => title.indexOf(state.search) >= 0),

        getList: state => state.list
            .filter(({name}) => {
                    return name.toLowerCase().indexOf(state.search.toLowerCase()) >= 0;
                }
            )
            .map(({developer, id, is_active, alias, name, updated_at_formatted}) => {
                return {
                    id,
                    name,
                    alias,
                    is_active: is_active ? 'Да' : 'Нет',
                    developer: developer && developer.name,
                    updated_at: updated_at_formatted
                };
            }),

        getItems: state => state.list.map(({id, name}) => {
            return {id, name};
        }),

        getById: state => _id => state.list.find(({id}) => id === _id),

        getCurrent: state => state.current,

        getFormatList: (state, getters) => {
            return getters.getList.map(obj => ({
                ...obj,
                activity: obj.activity ? 'Да' : 'Нет'
            }))
        }
    },

    actions: {
        async uploadPrice({commit}, form) {
            const {data} = await http.post('/admin/residentials/upload-price-list', form, {headers: {'content-type': 'application/x-www-form-urlencoded'}});
            commit('setValue', {price_list: data});
        },

        async getList({commit}) {
            try {
                const {data} = await http.post('/admin/residentials');
                commit('setList', data);
                console.log('data', data)
            } catch (e) {
                throw e;
            }
        },

        async remove({commit}, id) {
            await http.post('/admin/residentials/remove', {id});
            commit('clearCurrent');
        },

        async getParamsHack({commit, rootState}, id = 811) {
            const {data} = await http.post('/admin/residentials/edit', {id});
            const {residential, ...list} = data;
            commit('setItems', list, {root: true});
        },

        async getById({commit, rootState, state}, id) {
            if (id === null || id === 'new') {
                commit('clearCurrent');
                return;
            }

            const {data} = await http.post('/admin/residentials/edit', {id});
            const {residential, ...list} = data;

            // для infrastructures чтобы вытащить данные на уровень выше из pivot
            const infrastructures = residential.infrastructures.map(infrastructure => {
                let coordinatesString = '';
                if (infrastructure.pivot && infrastructure.pivot.latitude && infrastructure.pivot.longitude) {
                    coordinatesString = `${Number(infrastructure.pivot.latitude).toFixed(6)}, ${Number(infrastructure.pivot.longitude).toFixed(6)}`;
                }
                return {
                    ...infrastructure,
                    ...infrastructure.pivot,
                    coordinatesString
                }
            });

            // для ext_infrastructures
            const ext_infrastructures = residential.ext_infrastructures.map(ext_infra => {
                let coordinatesString = '';
                if (ext_infra.latitude && ext_infra.longitude) {
                    coordinatesString = `${Number(ext_infra.latitude).toFixed(6)}, ${Number(ext_infra.longitude).toFixed(6)}`;
                }
                return {
                    ...ext_infra,
                    coordinatesString
                }
            });

            commit('setItems', list, {root: true});
            commit('setValue', {
                ...residential,
                infrastructures,
                ext_infrastructures,
                ext_features: residential.ext_features.map(({name}) => name),
                floors: residential.floors.map(({floor}) => floor),
                features: residential.features.map(({id}) => id),
                balconies: residential.balconies.map(({id}) => id),
                banks: residential.banks.map(({id}) => id),
                wirings: residential.wirings.map(({id}) => id),
                decorations: residential.decorations.map(({id}) => id),
                materials: residential.materials.map(({id}) => id),
                advantages: residential.advantages.map(({id}) => id),
                layouts_advantages: residential.layouts_advantages.map(({id}) => id),
                elevators: residential.elevators.map(({count}) => count)
            });
        },


        async save({state}) {
            // Это новый элемент или редактирование?
            const isNew = state.current.id === 'new' || state.current.id === null;

            if (!isNew) {
                const {data: id} = await http.post('/admin/residentials/store', {
                    id: state.current.id,
                    is_active: state.current.is_active,
                    address: state.current.address,
                    landmark: state.current.landmark,
                    advantages: state.current.advantages,
                    alias: state.current.alias,
                    balconies: state.current.balconies,
                    banks: state.current.banks,
                    completion_deadline_from: state.current.completion_deadline_from,
                    completion_deadline_to: state.current.completion_deadline_to,
                    decorations: state.current.decorations,
                    detail_text: state.current.detail_text,
                    developer_id: state.current.developer_id,
                    developer_url: state.current.developer_url,
                    district_id: state.current.district_id,
                    elevators: state.current.elevators.map(count => ({count})),
                    ext_features: state.current.ext_features.filter(v => v).map(name => ({name})),
                    ext_infrastructures: state.current.ext_infrastructures,
                    features: state.current.features,
                    floors: state.current.floors.map(floor => ({floor})),
                    images: state.current.images,
                    infrastructures: state.current.infrastructures,
                    is_wide_logo_description: state.current.is_wide_logo_description,
                    is_apartments: state.current.is_apartments,
                    latitude: state.current.latitude,
                    layouts: state.current.layouts,
                    layouts_advantages: state.current.layouts_advantages,
                    longitude: state.current.longitude,
                    materials: state.current.materials,
                    name: state.current.name,
                    no_developer_logo: state.current.no_developer_logo,
                    original_image: state.current.original_image,
                    preview_picture: state.current.preview_picture,
                    preview_picture_alt: state.current.preview_picture_alt,
                    preview_picture_title: state.current.preview_picture_title,
                    preview_text: state.current.preview_text,
                    price_list: state.current.price_list,
                    price: stringToNumber(state.current.price),
                    sales_department_formulation: state.current.sales_department_formulation,
                    seo_description: state.current.seo_description,
                    seo_keywords: state.current.seo_keywords,
                    seo_title: state.current.seo_title,
                    short_description: state.current.short_description,
                    wirings: state.current.wirings,
                });
                return id;
            } else {
                const {data: id} = await http.post('/admin/residentials/store', {
                    is_active: state.current.is_active,
                    address: state.current.address,
                    landmark: state.current.landmark,
                    advantages: state.current.advantages,
                    alias: state.current.alias,
                    balconies: state.current.balconies,
                    banks: state.current.banks,
                    completion_deadline_from: state.current.completion_deadline_from,
                    completion_deadline_to: state.current.completion_deadline_to,
                    decorations: state.current.decorations,
                    detail_text: state.current.detail_text,
                    developer_id: state.current.developer_id,
                    developer_url: state.current.developer_url,
                    district_id: state.current.district_id,
                    elevators: state.current.elevators.map(count => ({count})),
                    ext_features: state.current.ext_features,
                    ext_infrastructures: state.current.ext_infrastructures,
                    features: state.current.features,
                    floors: state.current.floors.map(floor => ({floor})),
                    images: state.current.images,
                    infrastructures: state.current.infrastructures,
                    is_wide_logo_description: state.current.is_wide_logo_description,
                    is_apartments: state.current.is_apartments,
                    latitude: state.current.latitude,
                    layouts: state.current.layouts,
                    layouts_advantages: state.current.layouts_advantages,
                    longitude: state.current.longitude,
                    materials: state.current.materials,
                    name: state.current.name,
                    no_developer_logo: state.current.no_developer_logo,
                    original_image: state.current.original_image,
                    preview_picture: state.current.preview_picture,
                    preview_picture_alt: state.current.preview_picture_alt,
                    preview_picture_title: state.current.preview_picture_title,
                    preview_text: state.current.preview_text,
                    price_list: state.current.price_list,
                    price: stringToNumber(state.current.price),
                    sales_department_formulation: state.current.sales_department_formulation,
                    seo_description: state.current.seo_description,
                    seo_keywords: state.current.seo_keywords,
                    seo_title: state.current.seo_title,
                    short_description: state.current.short_description,
                    wirings: state.current.wirings,
                });
                return id;

            }

        }
    },
};
